import {
    WearThatXMaramMobile,
    HeroDesktopBannerMuzi,
} from "../../../public/Theme";
export const OPEN_MAIN_MENU = "Open main menu";
export const CLOSE_MENU_TEXT = "Close menu";
export const LOGO_ALT_TEXT = "Wearthat Logo";
export const GIFT_CARD_ENDPOINT = "/gift-card/";
export const DRAWER_NAVIGATION = "drawer-navigation";
export const HEADER_LOGO_IMAGE_ID = "header_logo_img_id";
export const HEADER_BUTTON_ID = "header_button_id";
export const COUNTRY_ICON_ALT = "country-icon";
export const BACK_TEXT = "BACK";
export const AR = "AR";
export const EN = "EN";
import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";

export const NewHeaderLinks = [
    {
        title: "Style Me",
        link: FRONTEND_ENDPOINTS?.STYLING,
        options: [
            {
                link: FRONTEND_ENDPOINTS?.BOX_SIGNUP,
                text: "Take Your Style Quiz",
                flyout_links: null,
            },
            // {
            //     link: FRONTEND_ENDPOINTS?.STYLISTS,
            //     text: "Meet Our Stylists",
            //     flyout_links: null,
            // },
            {
                link: FRONTEND_ENDPOINTS?.STYLE_MY_WARDROBE,
                text: "Style My Wardrobe",
                flyout_links: null,
            },
            // {
            //     link: FRONTEND_ENDPOINTS?.HOME,
            //     text: "Brands",
            //     flyout_links: null,
            // },
            {
                link: FRONTEND_ENDPOINTS?.JOURNALS,
                text: "Journals",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.MY_ORDERS,
                text: "My Orders",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.CONTACT_US,
                text: "Customer Service",
                flyout_links: null,
            },
        ],
    },
    {
        title: "Shop Now",
        link: FRONTEND_ENDPOINTS?.SHOP,
        options: [
            {
                link: FRONTEND_ENDPOINTS?.MARAM,
                text: "WearThat x Maram",
                flyout_links: null,
                // image: WearThatXMaramMobile,
            },
            {
                link: FRONTEND_ENDPOINTS?.SUMMER_SHOP,
                text: "The Summer Shop",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.MODEST_SHOP,
                text: "The Modest Shop",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.TAMARA,
                text: "WearThat x Tamara",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.SOHA,
                text: "WearThat x Soha",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.PRODUCTS,
                text: "Shop All",
                flyout_links: null,
            },
            // {
            //     link: FRONTEND_ENDPOINTS?.LATEST_PRODUCTS,
            //     text: "New Arrivals",
            //     flyout_links: null,
            // },

            // {
            //     link: FRONTEND_ENDPOINTS?.SERENA_SPRING,
            //     text: "Serena Spring",
            //     flyout_links: null,
            // },

            {
                link: "",
                text: "Collections",
                flyout_links: [
                    {
                        link: FRONTEND_ENDPOINTS?.MARAM,
                        text: "WearThat x Maram",
                        src: WearThatXMaramMobile,
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.TAMARA,
                        text: "Wear That x Tamara",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232937/New%20Website/Header/fnw0g4zulzi29r8dzkax.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SUMMER_SHOP,
                        text: "The Summer Shop",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1750064286/gdrrljg8punhxqkpjp8n.jpg",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.MODEST_SHOP,
                        text: "The Modest Shop",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1750064286/pcrgqie7hqd4bjbomzhs.jpg",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SPRING_ALL_EDIT,
                        text: "Serena Spring Edit",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232935/New%20Website/Header/ywvk7bels9ndoy8dfune.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SOHA,
                        text: "Wear That x Soha",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232936/New%20Website/Header/jnx7utd5eca4v2trmd13.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.WEARTHAT_X_MUZI,
                        text: "Wear That x Muzi",
                        src: HeroDesktopBannerMuzi,
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SERENA_RAMADAN,
                        text: "Ramadan Street",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232935/New%20Website/Header/s904do48u4kjmssdls4x.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SERENA_SPARKLES,
                        text: "Serena Sparkles",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232936/New%20Website/Header/okgzw6exqdnfjx26acmi.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.WEARTHAT_X_KIKA,
                        text: "Serena x Kika",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232935/New%20Website/Header/fuhf9uizw1tuhpeipshv.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.FALLING_FOR_SERENA_EDIT,
                        text: "Falling For Serena",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232935/New%20Website/Header/fmtx0uxymgad1cfwsmsn.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.ALL_EDITS_LINK,
                        text: "Work Edit",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/egeipgaegypor4hjjgyg.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.NEW_JESSIE_LINK,
                        text: "Jessie Collection",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232936/New%20Website/Header/vrfsdolxewsoahuodqoz.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.TAMARA_PRODUCTS_LINK,
                        text: "Wear That x Tamara",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/s61fwj2b0qg4ztl9ddl2.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.OLD_MONEY_EDIT_LINK,
                        text: "Old Money Edit",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232935/New%20Website/Header/jxzt7klqx3c8gaahg0fa.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SERENA_BY_THE_SEA_PRODUCTS_LINK,
                        text: "Serena By The Sea",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/f9r2q8fgexzlcwn0vi8q.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.SERENA_PRODUCTS_LINK,
                        text: "Serena Collection",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/rk87eqdv906emhmny5ay.webp",
                    },
                    {
                        link: FRONTEND_ENDPOINTS?.BASMA_PRODUCTS_LINK,
                        text: "Wear That x Basma",
                        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/gltqpetw3ixarx0zqupg.webp",
                    },
                    // {
                    //     link: FRONTEND_ENDPOINTS?.PRODUCTS,
                    //     text: "Shop All",
                    //     src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/rk87eqdv906emhmny5ay.webp",
                    // },
                ],
            },
            // {
            //     link: "",
            //     text: "Brands",
            //     flyout_links: [
            //         {
            //             link: FRONTEND_ENDPOINTS?.SERENA_PRODUCTS_LINK,
            //             text: "Show All Brands",
            //             src: "https://res.cloudinary.com/wearthat/image/upload/v1746110910/New%20Website/Header/mitms6rtsnrl9hitn4n4.jpg",
            //         },
            //         {
            //             link: FRONTEND_ENDPOINTS?.SERENA_PRODUCTS_LINK,
            //             text: "Serena Collections",
            //             src: "https://res.cloudinary.com/wearthat/image/upload/v1746110910/New%20Website/Header/mitms6rtsnrl9hitn4n4.jpg",
            //         },
            //         {
            //             link: FRONTEND_ENDPOINTS?.SERENA_PRODUCTS_LINK,
            //             text: "Serena Collections",
            //             src: "https://res.cloudinary.com/wearthat/image/upload/v1746110910/New%20Website/Header/mitms6rtsnrl9hitn4n4.jpg",
            //         },
            //     ],
            // },
            {
                link: FRONTEND_ENDPOINTS?.WISH_LIST,
                text: "Wishlist",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.MY_ORDERS,
                text: "My Orders",
                flyout_links: null,
            },
            {
                link: FRONTEND_ENDPOINTS?.CONTACT_US,
                text: "Customer Service",
                flyout_links: null,
            },
        ],
    },
];

export const LANGUAGE_BUTTON_TEXT = "Change Language ﺍﻟﹿﻌﹷﺮﹶﺑﻴﹽﺔ";
export const LANGUAGE_BUTTON_TEXT_ARABIC = "تغيير اللغة English";

export function slugify(string) {
    return string
        .toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "_");
}

export const HEADER_GIFT_CARD_BUTTON_ID = "header_gift_card_button_id";
export const HEADER_LOGIN_BUTTON_ID = "header_login_button_id";
export const CHANGE_LANGUAGE = "change_language";
export const MENU_ICON_ALT = "Menu Icon";
export const CLOSE_ICON_ALT = "close Icon";
export const LAZY = "lazy";
